"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  None: 0,
  Replace: 1,
  Add: 2,
  ColorBurn: 3,
  ColorDodge: 4,
  Darken: 5,
  Difference: 6,
  Divide: 7,
  Exclusion: 8,
  HardLight: 9,
  Lighten: 10,
  LinearBurn: 11,
  LinearDodge: 12,
  Multiply: 13,
  Negate: 14,
  Overlay: 15,
  Screen: 16,
  SoftLight: 17,
  Subtract: 18
};
exports["default"] = _default;